import styled, { css } from 'styled-components';
import { paletteHelper, spacingHelper, MultiAutocomplete } from '@construct-kit/core';

export const containerClassName = 'Container';

export const dangerouslySetClassNamesMultiAutocomplete = {
  textInputAndListboxContainer: 'InputListboxContainer',
  inputBorder: 'InputBorder',
  scrollableArea: 'InputContainer',
  input: 'Input',
  listboxWrapper: 'ListboxWrapper',
  listbox: 'Listbox',
  listboxOption: 'ListboxOption',
  noResultsMessage: 'NoResultsOption',
  contentWrapper: 'ContentWrapper',
  pill: 'Pill',
  pillDeleteButton: 'PillDeleteButton',
};

const lgScreenBorderRadius = '0.5rem';

export const largeScreenBtmBorderRadius = css`
  border-bottom-left-radius: ${lgScreenBorderRadius};
  border-bottom-right-radius: ${lgScreenBorderRadius};
`;

export const modalLocationSuggestStyles = css`
  .${containerClassName} {
    height: 100%;
  }

  .${dangerouslySetClassNamesMultiAutocomplete.textInputAndListboxContainer} {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .${dangerouslySetClassNamesMultiAutocomplete.inputBorder} {
    ::after {
      border: none;
      border-radius: 0;
      border-bottom: ${({ theme }) => theme.border.width.thin} solid
        ${paletteHelper('borderSecondary')};
    }
  }

  .${dangerouslySetClassNamesMultiAutocomplete.scrollableArea} {
    padding: ${spacingHelper('medium twoExtraSmall twoExtraSmall 0')};
  }

  .${dangerouslySetClassNamesMultiAutocomplete.listboxWrapper} {
    top: 0;
    overflow: auto;
    position: relative;
    transform: none;
    padding: 0;
  }

  .${dangerouslySetClassNamesMultiAutocomplete.listbox} {
    border: none;
    max-height: 100%;
  }
`;

export const largeScreenLocationSuggestStyles = css`
  .${dangerouslySetClassNamesMultiAutocomplete.inputBorder} {
    border-radius: 0.5rem;
    ::after {
      border: none;
      border-bottom: ${({ theme }) => theme.border.width.thin} solid
        ${paletteHelper('borderSecondary')};
    }
  }

  .${dangerouslySetClassNamesMultiAutocomplete.scrollableArea} {
    padding: ${spacingHelper('medium 8rem medium medium')};
  }

  .${dangerouslySetClassNamesMultiAutocomplete.input} {
    margin-bottom: 0;
  }

  .${dangerouslySetClassNamesMultiAutocomplete.contentWrapper} {
    grid-row-gap: ${spacingHelper('extraSmall')};
    row-gap: ${spacingHelper('extraSmall')};

    span span {
      max-width: 200px;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .${dangerouslySetClassNamesMultiAutocomplete.pill} {
    margin-bottom: 0;
  }

  .${dangerouslySetClassNamesMultiAutocomplete.listboxWrapper} {
    background-color: ${paletteHelper('backgroundPrimaryBase')};
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  }

  .${dangerouslySetClassNamesMultiAutocomplete.listbox} {
    border: none;
    border-top: ${({ theme }) => theme.border.width.thin} solid ${paletteHelper('borderSecondary')};
    max-height: 369px;
    width: calc(${spacingHelper('100% - large')});
    margin: ${spacingHelper('0 small small small')};
  }
`;

export const StyledMultiLocationSuggest = styled(MultiAutocomplete)<{
  showRecentLocations: boolean;
  top: number;
}>`
  #location-suggestions-heading {
    margin-left: 1rem;
    margin-bottom: 1rem;
  }
  #recent-location-heading {
    display: none;
  }

  #location-suggestions-heading {
    color: ${paletteHelper('textSecondary')};
  }

  input::placeholder {
    font-weight: 400;
  }

  .${dangerouslySetClassNamesMultiAutocomplete.pillDeleteButton} svg {
    stroke-width: 0.5px;
  }

  .LocationSearchListboxOption:only-child,
  .${dangerouslySetClassNamesMultiAutocomplete.noResultsMessage} {
    margin-bottom: ${spacingHelper('small')};
  }

  .${dangerouslySetClassNamesMultiAutocomplete.scrollableArea} {
    max-height: 100%;
    top: 0;
  }

  ${({ showRecentLocations }) =>
    !showRecentLocations &&
    `
      .ListboxOption:last-child::before {
        content: 'Search for:';
        margin-right: 0.75rem;
      }

      .ListboxOption:last-child {
        svg {
          display: none;
        }
      }
    `}

  ${({ showRecentLocations, top }) =>
    showRecentLocations &&
    css`
      #recent-location-heading {
        display: block;
        color: #6e7275;
        margin-left: 1rem;
        margin-bottom: 1rem;
      }
      #location-suggestions-heading {
        display: none;
      }
      .${dangerouslySetClassNamesMultiAutocomplete.listboxWrapper} {
        top: ${top}px;
      }
    `}
`;
